module.exports = __webpack_public_path__ + "img/dashboard-wizard-task-list-bg.f2e36bc4.svg";